<template>  
<div> <!-- root element start -->


    <div class="container-fluid mt-1">

          <div class="row">
            <div class="col-12 col-lg-6 order-2 order-lg-1">
              <div class="row">
                <div class="col-12">
                  
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-lg-6">
                  
                </div>
                <div class="col-12 col-lg-6">
                  
                </div>
              </div>
            </div>


            <div class="col-12 col-lg-6 order-1 order-lg-2">
              
            </div>

           </div>

    </div><!--  end container-fluid div -->
</div> <!-- root element end -->
</template>


<script>
import {store} from '../../stores/user-dashboard-main-store.js'



export default {
  store,
  props: ['org_id'],
  data: function () {
    return { 

    }
  },
  computed: {
    rightView () { return this.$store.state.rightView },
    prop1 () { return this.$store.state.prop1 },
    prop2 () { return this.$store.state.prop2 },
    prop3 () { return this.$store.state.prop3 },
  },
  watch: {
    
  },
  mounted() {
   
  },
  methods: {
    changeRightView(name, prop1, prop2, prop3) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2, prop3: prop3 }); },
    

    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'contact-add':
        // code to run the "get all contacts method" from store
        _this.getLatestUserContacts();
        
        break;
        case 'org-add':
        // code to run the "get all contacts method" from store
        _this.getLatestUserOrgs();
        
        break;
        case 'quote-save':
        _this.getLatestUserQuotes();
        break;
        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {
        

        default:
      }
    },
    onSecondary(value) {

    },

  },    
  components:{
  	

  },
  filters: {

  }
}
</script>
